  //Makes an asynchronous call to the server to delete a users profile photo
  window.deleteProfilePhotoFromServer = function(uri, slug) {
    var fd = new FormData();
    var xhr = new XMLHttpRequest();
    xhr.open('DELETE', uri, true);
    xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
    fd.append('slug', slug);
    xhr.send(fd);
  };